'use client';

import { tokenRef } from 'common/constant';
import applyBranding, { getSubdomain } from 'lib/branding';
import { ReactNode, createContext, useEffect } from 'react';
import { useGetAdminPermissionList, useGetOrginazation } from 'service/auth.query';
interface OrginazationConfig {
  logo: string;
  background_image: string;
  title: string;
  domain_name: string;
  address: string;
  phone_number: string;
  login_image: string;
  register_image: string;
}
interface Permission {
  can_add: boolean;
  can_delete: boolean;
  can_update: boolean;
  can_view: boolean;
  module_code: string;
  module_id: number;
  module_name: string;
}

interface ConfigurationContextProps {
  appConfig?: OrginazationConfig;
  permission: Permission[];
}

export const ConfigurationContext = createContext<ConfigurationContextProps>({
  appConfig: {
    logo: '',
    background_image: '',
    title: '',
    domain_name: '',
    address: '',
    phone_number: '',
    login_image: '',
    register_image: ''
  },
  permission: []
});
function ConfigurationContextProvider({ children }: { children: ReactNode }) {
  const token = window.localStorage[tokenRef] ? JSON?.parse(window.localStorage[tokenRef]) : null;

  const isAuthenticated = !!token;
  const domainFirstname = getSubdomain();

  const { data: appConfiguration } = useGetOrginazation(domainFirstname, true);

  const { data: adminPermissionList } = useGetAdminPermissionList(isAuthenticated);

  // keep the tab title, description and favicon in sync with the organization
  // the backend reports for this domain
  useEffect(() => {
    applyBranding({ title: appConfiguration?.title, logo: appConfiguration?.logo });
  }, [appConfiguration?.title, appConfiguration?.logo]);

  return (
    <ConfigurationContext.Provider
      value={{
        appConfig: appConfiguration,
        permission: adminPermissionList?.permissions
      }}>
      {children}
    </ConfigurationContext.Provider>
  );
}

export default ConfigurationContextProvider;
